export const STAGES = [
  {
    key: "conception",
    n: "01",
    label: "Conception",
    title: "The idea",
    short: "An idea that won't leave you alone. Nothing has met a paying customer yet.",
    body: "You have an idea that won't leave you alone — but nothing has been asked to survive contact with a paying customer yet. This stage is about deciding whether the idea deserves the next year of your life.",
    needs: "Evidence. Conversations with the people you think will buy, and one small, real test.",
    tooSoon: "Branding, business plans, hiring, or raising money for something that hasn't been validated.",
    question: "What is the cheapest way to find out whether anyone will actually pay for this?",
    lessOn: "How do I build the whole thing?",
    moreOn: "What is the smallest thing I can prove first?",
  },
  {
    key: "infancy",
    n: "02",
    label: "Infancy",
    title: "Proving it can work",
    short: "First sales. The business needs almost everything from you.",
    body: "You've made it real. Someone has paid you — or is about to. Now the business needs almost everything from you, and most of your assumptions are still being tested.",
    needs: "Survival and truth. Runway, relentless learning and a clear picture of who is actually buying and why.",
    tooSoon: "Scaling marketing, building infrastructure or optimizing before you know what's really working.",
    question: "What has the market actually proven — and what am I still assuming?",
    lessOn: "How do I look like a real company?",
    moreOn: "What is actually true about my customer?",
  },
  {
    key: "toddler",
    n: "03",
    label: "Toddler Years",
    title: "Making it work consistently",
    short: "Something works. Now can you make it work again and again?",
    body: "You've moved beyond proving that the idea can work. Now you're discovering whether you can make it work consistently. This stage often feels chaotic because you're solving new problems almost as quickly as you create them.",
    needs: "Predictability. Repeatable sales, cleaner economics and a few systems that don't depend on heroics.",
    tooSoon: "Expansion — new products, new markets or headcount — before the core is reliable.",
    question: "What needs to become predictable before I grow?",
    lessOn: "How big can I make this?",
    moreOn: "What needs to become predictable before I grow?",
  },
  {
    key: "childhood",
    n: "04",
    label: "Childhood",
    title: "Forming an identity",
    short: "Customers know you. A repeatable business is emerging.",
    body: "Your business has an identity forming. Customers know who you are and something repeatable is emerging. The work now is choosing what you stand for — and what you won't chase.",
    needs: "Focus. A clear customer, a sharpened position and the discipline to say no to good ideas.",
    tooSoon: "Diversifying into everything that looks like an opportunity.",
    question: "Which customer and which promise deserve the next twelve months?",
    lessOn: "What else could we sell?",
    moreOn: "What do we want to be known for?",
  },
  {
    key: "adolescence",
    n: "05",
    label: "Adolescence",
    title: "Growth changes everything",
    short: "Growth has arrived — and brought entirely new problems.",
    body: "Growth has arrived — and it's creating entirely new problems. People, cash, systems and competition are moving faster than the structures underneath them.",
    needs: "Structure without bureaucracy. Real roles, real numbers and a founder learning to lead instead of do.",
    tooSoon: "Big strategic bets while the fundamentals are still catching up.",
    question: "How do we grow without breaking what already works?",
    lessOn: "How fast can we go?",
    moreOn: "What has to be true for growth not to break us?",
  },
  {
    key: "growing-pains",
    n: "06",
    label: "Growing Pains",
    title: "Leading what you built",
    short: "Established, but straining. Leadership, capital and culture are the questions.",
    body: "The business is established but straining. Leadership, capital and culture are the questions now — and the answers change what your role becomes.",
    needs: "Leadership depth, capital discipline and honest decisions about what the founder should stop doing.",
    tooSoon: "Assuming the next stage will look like the last one, only bigger.",
    question: "What does this business need from me now that it didn't before?",
    lessOn: "How do I stay involved in everything?",
    moreOn: "What should I stop doing so the business can grow?",
  },
  {
    key: "maturity",
    n: "07",
    label: "Maturity",
    title: "What comes next",
    short: "It runs. The question is what it's for — and what happens next.",
    body: "You've built something that runs. The question is no longer \u201Ccan this work?\u201D — it's \u201Cwhat is this for, and what happens next?\u201D",
    needs: "Renewal. New initiatives treated as infants, not extensions — and a plan for what this becomes without you.",
    tooSoon: "Expecting a brand-new initiative to perform like the mature company that funds it.",
    question: "What is the next chapter — and which of my new ideas is still an infant?",
    lessOn: "How do we protect what we have?",
    moreOn: "Which of our new ideas is still an infant?",
  },
];

export const stageAt = (score) => STAGES[Math.min(STAGES.length - 1, Math.max(0, Math.round(score) - 1))];
